import { call, put } from 'redux-saga/effects';
import { CallApi } from '../api/callApi';
import { APIS } from '../../_config';

export function* getSessions(action: any): any {
  try {
    yield put({ type: 'CHAT_SESSIONS/LOADING', payload: true });
    const resp = yield call(CallApi.GET, APIS.CHAT_SESSIONS.LIST, {}, true);
    if (resp.status >= 200 && resp.status < 300) {
      yield put({ type: 'CHAT_SESSIONS/SET', payload: resp.data });
      action?.callbackSuccess?.(resp);
    } else {
      yield put({ type: 'CHAT_SESSIONS/LOADING', payload: false });
      action?.callbackError?.(resp);
    }
  } catch (e: any) {
    yield put({ type: 'CHAT_SESSIONS/LOADING', payload: false });
    action?.callbackError?.(e);
  }
}

export function* createSession(action: any): any {
  try {
    const resp = yield call(CallApi.POST, APIS.CHAT_SESSIONS.CREATE, {});
    if (resp.status >= 200 && resp.status < 300) {
      action?.callbackSuccess?.(resp);
    } else {
      action?.callbackError?.(resp);
    }
  } catch (e: any) {
    action?.callbackError?.(e);
  }
}

export function* deleteSession(action: any): any {
  try {
    const resp = yield call(CallApi.DELETE, APIS.CHAT_SESSIONS.DELETE(action.payload.session_id), {});
    if (resp.status >= 200 && resp.status < 300) {
      action?.callbackSuccess?.(resp);
    } else {
      action?.callbackError?.(resp);
    }
  } catch (e: any) {
    action?.callbackError?.(e);
  }
}

export function* getMessages(action: any): any {
  try {
    const resp = yield call(CallApi.GET, APIS.CHAT_SESSIONS.MESSAGES(action.payload.session_id), {}, true);
    if (resp.status >= 200 && resp.status < 300) {
      action?.callbackSuccess?.(resp);
    } else {
      action?.callbackError?.(resp);
    }
  } catch (e: any) {
    action?.callbackError?.(e);
  }
}

export function* querySession(action: any): any {
  try {
    const { session_id, question } = action.payload;
    const resp = yield call(CallApi.POST, APIS.CHAT_SESSIONS.QUERY(session_id), { question });
    if (resp.status >= 200 && resp.status < 300) {
      action?.callbackSuccess?.(resp);
    } else {
      action?.callbackError?.(resp);
    }
  } catch (e: any) {
    action?.callbackError?.(e);
  }
}
